exports.text2 = () => {
    return `Contact me <br/> Email: kenneth.kreindler@🟦win.ch (replace the square with "blue")<br/>
    LinkedIn: https://linkedin.com/in/kennethkreindler <br/>
    <br/>  
  `
  };
